import { Toaster as SonnerToaster } from 'sonner';
import { BRAND } from '@/lib/brand';

/**
 * App-wide toast renderer. Sonner provides accessible toasts; we override
 * the default look so it matches the Virro card aesthetic (white surface,
 * Linen-dark border, no shadow).
 *
 * IMPORTANT: success / error / warning toasts must be visually distinct.
 * Earlier we set `richColors={false}` and a single white style for every
 * variant — error toasts then looked identical to success ones, which
 * silently masked failures (e.g. the MFA-enroll 422 path showing what
 * appeared to be a "code sent" success). We keep the brand-tinted base
 * style but add per-variant accents so users can tell at a glance whether
 * something worked.
 */
export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-right"
      richColors
      toastOptions={{
        classNames: {
          toast:
            'rounded-xl border font-normal data-[type=success]:!bg-emerald-50 data-[type=success]:!text-emerald-900 data-[type=success]:!border-emerald-200 data-[type=error]:!bg-red-50 data-[type=error]:!text-red-900 data-[type=error]:!border-red-200 data-[type=warning]:!bg-amber-50 data-[type=warning]:!text-amber-900 data-[type=warning]:!border-amber-200',
        },
        style: {
          background: '#FFFFFF',
          color: BRAND.humus,
          border: `1px solid ${BRAND.linenDark}`,
          borderRadius: '12px',
          fontFamily: 'inherit',
          fontWeight: 400,
        },
      }}
    />
  );
}
